import { IClassname } from '@/lib/shared/model/classname';

export const Water = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14444_570)">
        <path
          d="M22.3898 19.2336C22.3898 20.0727 22.2245 20.9036 21.9034 21.6788C21.5823 22.4541 21.1116 23.1584 20.5183 23.7518C19.925 24.3451 19.2206 24.8157 18.4454 25.1369C17.6701 25.458 16.8393 25.6232 16.0002 25.6232C15.1611 25.6232 14.3302 25.458 13.555 25.1369C12.7798 24.8157 12.0754 24.3451 11.4821 23.7518C10.8887 23.1584 10.4181 22.4541 10.097 21.6788C9.77587 20.9036 9.6106 20.0727 9.6106 19.2336C9.6106 16.3456 13.9172 9.16367 15.4635 6.68451C15.5191 6.59188 15.5978 6.51524 15.6918 6.46203C15.7859 6.40882 15.8921 6.38086 16.0002 6.38086C16.1082 6.38086 16.2145 6.40882 16.3085 6.46203C16.4026 6.51524 16.4812 6.59188 16.5369 6.68451C18.0832 9.16367 22.3898 16.3456 22.3898 19.2336Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.64908 19.2332C1.20513 17.2202 1.18961 15.1364 1.60355 13.117C2.01749 11.0977 2.85161 9.18797 4.05174 7.51201C5.25186 5.83605 6.79114 4.43131 8.56958 3.38904C10.348 2.34678 12.3258 1.6903 14.3745 1.46227C16.4232 1.23424 18.497 1.43974 20.4611 2.06544C22.4251 2.69114 24.2356 3.72303 25.7749 5.09408C27.3142 6.46513 28.5478 8.14466 29.3957 10.0236C30.2435 11.9025 30.6866 13.9388 30.6961 16.0001C30.6993 17.0745 30.5836 18.1459 30.3511 19.1949"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.3799 22.1338C28.9394 23.0759 28.4041 23.9708 27.7825 24.8046"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.7763 27.0029C24.9886 27.6935 24.1321 28.3016 23.2205 28.8176"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.524 30.0566C19.5386 30.3712 18.5239 30.5853 17.4954 30.6956"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.505 30.6573C13.4778 30.5595 12.4631 30.3582 11.4763 30.0566"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.74162 28.7785C7.82993 28.2625 6.97352 27.6545 6.18579 26.9639"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.21776 24.8046C3.59088 23.9743 3.05532 23.0789 2.62036 22.1338"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14444_570">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
